import React from 'react';

export default function AppLoader({
  lines = 3,
  size = 'md',
  inline = false,
  className = '',
  label = '',
}) {
  const safeLines = Math.max(1, Math.min(6, Number(lines) || 1));
  const rootClass = [
    'app-loader',
    inline ? 'app-loader--inline' : '',
    size === 'sm' ? 'app-loader--sm' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={rootClass} role='status' aria-live='polite' aria-label={label || 'Loading'}>
      {Array.from({ length: safeLines }).map((_, index) => (
        <span
          key={`app-loader-line-${index}`}
          className={`app-loader-line ${index === 0 ? 'app-loader-line--title' : ''}`}
        ></span>
      ))}
      {label ? <span className='visually-hidden'>{label}</span> : null}
    </div>
  );
}
